import { render } from "./xCargoVisionPage.vue?vue&type=template&id=22ef6ca0&scoped=true"
import script from "./xCargoVisionPage.vue?vue&type=script&lang=js"
export * from "./xCargoVisionPage.vue?vue&type=script&lang=js"

import "./xCargoVisionPage.vue?vue&type=style&index=0&id=22ef6ca0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ef6ca0"]])

export default __exports__